module.exports = __webpack_public_path__ + "static/Rotated-Chart-8bdf98df2f9a704afdd01189949d06ff.png";